import { USER_ROLES } from './app.config';
import { AppGuard } from './app.guard';
import { CalendarPreviewComponent } from './calendar/calendar.component';
import { ChannelsComponent } from './channels/channels.component';
import { CompaniesComponent } from './companies/companies.component';
import { OwnersComponent } from './owners/owners.component';
import { CompanyComponent } from './company/company.component';
import { DeviceEditComponent } from './device-edit/device-edit.component';
import { DevicesComponent } from './devices/devices.component';
import { LoginComponent } from './login/login.component';
import { MediaComponent } from './media/media.component';
import { PlaylistEditComponent } from './playlist-edit/playlist-edit.component';
import { PlaylistSlideshowComponent } from './playlist-slideshow/playlist-slideshow.component';
import { PlaylistComponent } from './playlist/playlist.component';
import { UsersComponent } from './users/users.component';
import { HelpComponent } from './help/help.component';
import { AdminComponent } from './admin/admin.component';
import { PlaylistEditResolveService } from './playlist-edit/playlist-edit-resolve.service';
import { NewsComponent } from './news/news.component';
import { BusComponent } from './bus/bus.component';
import { EinkdevicesComponent } from './einkdevices/einkdevices.component';

export const routes = [
  { path: '', component: LoginComponent },
  {
    path: 'owners',
    component: OwnersComponent,
    canActivate: [AppGuard],
    data: { roles: [USER_ROLES.ADMINISTRATOR] },
  },
  // Only for USER_ROLES.ADMINISTRATOR
  //
  {
    path: 'companies/:companyOwnerId',
    component: CompaniesComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
      ]
    },
  },
  {
    path: 'companies',
    component: CompaniesComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        // The Administrator will be able to access particular
        //   business owner companies by accessing /companies/businesOwnerId
        //   USER_ROLES.ADMINISTRATOR,
        // Business owners will see their companies
        USER_ROLES.BUSINESS_OWNER
      ]
    },
  },
  {
    path: 'company/:companyId',
    component: CompanyComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.BUSINESS_OWNER,
        USER_ROLES.COMPANY_ADMIN,
        USER_ROLES.COMPANY_EDITOR,
      ],
    },
  },
  {
    path: 'users/:companyId',
    component: UsersComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.BUSINESS_OWNER,
        USER_ROLES.COMPANY_ADMIN
      ]
    },
  },
  {
    path: 'channels/:companyId',
    component: ChannelsComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.BUSINESS_OWNER,
        USER_ROLES.COMPANY_ADMIN
      ]
    },
  },
  {
    path: 'media/:companyId',
    component: MediaComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.BUSINESS_OWNER,
        USER_ROLES.COMPANY_ADMIN,
        USER_ROLES.COMPANY_EDITOR,
      ],
    },
  },
  {
    path: 'playlist/:companyId',
    component: PlaylistComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.BUSINESS_OWNER,
        USER_ROLES.COMPANY_ADMIN,
        USER_ROLES.COMPANY_EDITOR,
        USER_ROLES.COMPANY_VIEWER,
      ],
    },
  },
  {
    path: 'calendar/:companyId',
    component: CalendarPreviewComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.BUSINESS_OWNER,
        USER_ROLES.COMPANY_ADMIN,
        USER_ROLES.COMPANY_EDITOR,
        USER_ROLES.COMPANY_VIEWER,
      ],
    },
  },
  {
    path: 'playlist-edit/:companyId/:playlistId',
    component: PlaylistEditComponent,
    resolve: {
      playlist: PlaylistEditResolveService
    },
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.BUSINESS_OWNER,
        USER_ROLES.COMPANY_ADMIN,
        USER_ROLES.COMPANY_EDITOR,
        USER_ROLES.COMPANY_VIEWER,
      ],
    },
  },
  {
    path: 'slideshow/:playlistId/company/:companyId',
    component: PlaylistSlideshowComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.BUSINESS_OWNER,
        USER_ROLES.COMPANY_ADMIN,
        USER_ROLES.COMPANY_EDITOR,
        USER_ROLES.COMPANY_VIEWER,
      ],
    },
  },
  {
    path: 'devices/:companyId',
    component: DevicesComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.BUSINESS_OWNER,
        USER_ROLES.COMPANY_ADMIN
      ],
    },
  },
  {
    path: 'device-edit/:companyId',
    component: DeviceEditComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.BUSINESS_OWNER,
        USER_ROLES.COMPANY_ADMIN
      ],
    },
  },
  {
    path: 'device-edit/:companyId/:deviceId',
    component: DeviceEditComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.BUSINESS_OWNER,
        USER_ROLES.COMPANY_ADMIN
      ],
    },
  },
  {
    path: 'help/:companyId',
    component: HelpComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.BUSINESS_OWNER,
        USER_ROLES.COMPANY_ADMIN,
        USER_ROLES.COMPANY_EDITOR,
        USER_ROLES.COMPANY_VIEWER,
      ],
    },
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.ADMINISTRATOR,
      ],
    },
  },
  { path: 'news/:companyId', component: NewsComponent,
    canActivate: [AppGuard],
    data: {
      roles: [
        USER_ROLES.LPP_EDITOR,
        USER_ROLES.ADMINISTRATOR,
        USER_ROLES.COMPANY_ADMIN,
        USER_ROLES.COMPANY_EDITOR,
        USER_ROLES.BUSINESS_OWNER
      ],
    },

},
{ path: 'bus/:companyId', component: BusComponent,
canActivate: [AppGuard],
data: {
  roles: [
    USER_ROLES.LPP_EDITOR,
    USER_ROLES.ADMINISTRATOR,
    USER_ROLES.COMPANY_ADMIN,
    USER_ROLES.COMPANY_EDITOR
  ],
},

},
{ path: 'einkdevices/:companyId', component: EinkdevicesComponent,
canActivate: [AppGuard],
data: {
  roles: [
    USER_ROLES.LPP_EDITOR,
    USER_ROLES.ADMINISTRATOR,
    USER_ROLES.COMPANY_ADMIN,
    USER_ROLES.COMPANY_EDITOR,
    USER_ROLES.BUSINESS_OWNER
  ],
},

},
  { path: '**', redirectTo: '' },
];



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/app.routes.ts